import webdesignIcon from "../components/images/webdesign-icon.png";
import apiIcon from "../components/images/api-icon.png";
import databaseIcon from "../components/images/database-icon.png";
import mobileAppsIcon from "../components/images/mobile-apps-icon.png";

export const ourServicesDummyData = [
  {
    icon: webdesignIcon,
    alt: "some text",
    title: "Webdesign",
    description: "Lorem ipsum dolor sit amet"
  },
  {
    icon: apiIcon,
    alt: "some text",
    title: "API development",
    description: "Lorem ipsum dolor sit amet"
  },
  {
    icon: databaseIcon,
    alt: "some text",
    title: "Backend ",
    description: "Lorem ipsum dolor sit amet"
  },
  {
    icon: mobileAppsIcon,
    alt: "some text",
    title: "Mobile apps",
    description: "Lorem ipsum dolor sit amet"
  }
];
